export default __webpack_public_path__ + "static/media/replied-arrow-back-up.cb24c507.svg";